<template>
  <Wrap>
    <FormFloat :title="$t('title')">
      <Notice v-if="message" ref="Message-scroll" :class="message.theme">
        {{ message.text }}
      </Notice>
      <Btn v-if="!isVerified && signupEmail" :disabled="verifyAskedDiff > 0" @click="reverify">
        {{ $t('resend') }}
        <template v-if="verifyAskedDiff > 0">
          ({{ verifyAskedDiff }})
        </template>
      </Btn>
      <Row>
        <Column :sm="6">
          <Btn class="success" to="Login">
            {{ $t('login') }}
          </Btn>
        </Column>
        <Column :sm="6">
          <Btn class="neutral" to="Index">
            {{ $t('back') }}
          </Btn>
        </Column>
      </Row>
    </FormFloat>
  </Wrap>
</template>

<script>
import { actions, getters } from '@utils'
import FormFloat from '@forms/FormFloat'
import Message from '@mixins/Message'
import Meta from '@mixins/Meta'

export default {
  mixins: [
    Message,
    Meta(),
  ],
  components: { FormFloat },
  data() {
    return {
      interval: null,
      nowTime: Date.now(),
      verifyAskedAt: null,
    }
  },
  computed: {
    isVerified() {
      return !!Number(this.$route.query.verified)
    },
    verifyAskedDiff() {
      return ~~(((this.verifyAskedAt + (60 * 1000)) - this.nowTime) / 1000)
    },
    ...getters('signupEmail'),
  },
  methods: {
    incrementTime() {
      this.nowTime += 1000
    },
    async reverify() {
      this.verifyAskedAt = Date.now()

      try {
        await this.PATCH_AUTHMANAGEMENT({
          id: null,
          email: this.signupEmail,
          isVerifyTokenRequest: true,
        })
        this.success(this.$t('sent'))
      } catch (error) {
        this.setErrorMessage(error)
      }
    },
    ...actions('PATCH_AUTHMANAGEMENT'),
  },
  created() {
    this.verifyAskedAt = Date.now()

    const successMessage = [
      this.$t('success'),
      ...this.isVerified
        ? [this.$t('loginNow')]
        : [this.$t('checkEmail')],
    ].join(' ')

    this.success(successMessage)

    this.interval = setInterval(this.incrementTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": "Complete registration"
    },
    "login": "Login",
    "title": "Complete registration",
    "resend": "Resend verification email.",
    "back": "Go to homepage",
    "sent": "New verification email sent!",
    "success": "You have successfully signed up!",
    "loginNow": "You can now login.",
    "checkEmail": "Please check your inbox to verify your email address."
  }
}
</i18n>
